import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiSearch, FiCalendar, FiTag, FiArrowRight } from "react-icons/fi";
import blogData from "../../data/blogs/Blog.json";
import BlogItem from "../../components/body/blogpagecomponents/Blogitem";
import HandlePagination from "../../components/body/blogpagecomponents/HandlePagination";
import Navbar from "../../components/Navbar/Navbar";
import Main_Footer from "../../components/footer/IndiaFooter/Main_Footer";
import Banner from "../../components/body/topLocationsComponents/Banner";
import { BannerData } from "../../Location/data";

const categories = [
  { name: "Real Estate News", count: 12 },
  { name: "Gurugram News", count: 8 },
  { name: "Pune News", count: 5 },
  { name: "Mumbai News", count: 7 },
  { name: "Bangaluru News", count: 3 },
];

const tags = [
  "Luxury Homes",
  "Investment",
  "Interior Design",
  "Market Analysis",
  "Home Loans",
  "Property Tips",
  "Real Estate News",
  "Home Buying",
];

const BlogList = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [category, setCategory] = useState(null);
  const productsPerPage = 4;
  const offset = currentPage * productsPerPage;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const dataCategory = params.get("category");
    setCategory(dataCategory);
  }, [location.search]);

  let filteredData = blogData.filter((blog) => {
    let isCategoryMatched = true;
    if (category) {
      isCategoryMatched =
        blog.category === category && blog.category !== "underwear";
    } else {
      isCategoryMatched = blog.category !== "underwear";
    }
    return isCategoryMatched;
  }).reverse(); // Reverse the order to show newest blogs first

  if (filteredData.length === 0) {
    filteredData = [
      {
        id: "no-data",
        category: "no-data",
        tag: "no-data",
        title: "no-data",
        date: "no-data",
        author: "no-data",
        avatar: "no-data",
        thumbImg: "",
        coverImg: "",
        subImg: ["", ""],
        shortDesc: "no-data",
        description: "no-data",
        slug: "no-data",
      },
    ];
  }

  const pageCount = Math.ceil(filteredData.length / productsPerPage);

  const handlePageChange = (selected) => {
    setCurrentPage(selected);
  };

  // Get popular posts (first 3 posts for demo)
  const popularPosts = useMemo(() => {
    return [...blogData].slice(-3).reverse();
  }, [blogData]);

  return (
    <>
      <Navbar />
      <Banner BannerData={BannerData} />
      <div className="blog list md:py-20 py-10 text-black">
        <div className="container text-black">
          <div className="flex justify-between max-xl:flex-col gap-12">
            {/* Main Content */}
            <div className="left xl:w-3/4">
              <div className="list-blog grid grid-cols-1 gap-8">
                {filteredData
                  .slice(offset, offset + productsPerPage)
                  .map((item) => (
                    <div key={item.id} className="w-full">
                      <BlogItem data={item} />
                    </div>
                  ))}
              </div>
              {pageCount > 1 && (
                <div className="list-pagination w-full flex justify-center items-center md:mt-10 mt-12">
                  <HandlePagination
                    pageCount={pageCount}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                    className="pagination"
                  />
                </div>
              )}
            </div>

            {/* Sidebar */}
            <div className="xl:w-1/4 md:w-full hidden md:block">
             
              {/* Popular Posts */}
              <div className="bg-[#F7F7F7] rounded-xl border border-gray-100 p-6 mb-8">
                <h3 className="text-xl font-semibold mb-6">Popular Posts</h3>
                <div className="space-y-6">
                  {popularPosts.map((post, index) => (
                    <div
                      key={index}
                      className="flex gap-3 group cursor-pointer"
                    >
                      <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                        <img
                          src={post.thumbImg}
                          alt={post.h1Heading}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                        />
                      </div>
                      <div>
                        <h4 className="text-sm font-bold text-gray-800 group-hover:text-primary transition-colors line-clamp-2">
                          {post.h1Heading}
                        </h4>
                        <div className="flex items-center text-sm text-gray-500 mt-1">
                          <FiCalendar className="mr-1.5" size={14} />
                          <span>{post.date}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Categories */}
              {/* <div className="bg-[#F7F7F7] rounded-xl border border-gray-100 p-6 mb-8">
                <h3 className="text-xl font-semibold mb-6">Categories</h3>
                <ul className="space-y-3">
                  {categories.map((category, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center group cursor-pointer"
                    >
                      <div className="flex items-center">
                        <FiTag
                          className="mr-2 text-gray-400 group-hover:text-primary transition-colors"
                          size={16}
                        />
                        <span className="text-gray-600 group-hover:text-primary transition-colors">
                          {category.name}
                        </span>
                      </div>
                      <span className="bg-gray-100 text-gray-600 text-xs font-medium px-2.5 py-0.5 rounded-full">
                        {category.count}
                      </span>
                    </li>
                  ))}
                </ul>
              </div> */}

              {/* Popular Tags */}
              {/* <div className="bg-[#F7F7F7] rounded-xl border border-gray-100 p-6">
                <h3 className="text-xl font-semibold mb-6">Popular Tags</h3>
                <div className="flex flex-wrap gap-2">
                  {tags.map((tag, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center bg-gray-50 hover:bg-primary hover:text-gray text-gray-600 text-sm px-3 py-1.5 rounded-full transition-colors cursor-pointer border border-gray-200 hover:border-primary"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div> */}

              {/* Newsletter Signup */}
              <div className="bg-[#F7F7F7] rounded-xl p-6 mt-8 text-black border border-gray-100">
                <h3 className="text-xl font-semibold mb-3">
                  Subscribe to Our Newsletter
                </h3>
                <p className="text-sm   mb-4">
                  Get the latest property news and updates delivered to your
                  inbox.
                </p>
                <div className="relative">
                  <input
                    type="email"
                    placeholder="Your email address"
                    className="w-full bg-white/20 backdrop-blur-sm border border-white/30 rounded-lg py-3 px-4 pr-10 text-black placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary/50"
                  />
                  <button className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white text-black p-1.5 rounded-md hover:bg-gray-100 transition-colors">
                    <FiArrowRight size={20} />
                  </button>
                </div>
              </div>
            </div>

            
          </div>
        </div>
      </div>
      <Main_Footer />
    </>
  );
};

export default BlogList;
